// stores/reports/reportsStore.js
import { defineStore } from 'pinia';
import { api } from '../../services/api';
import { useAuthStore } from '../auth';

export const useReportsStore = defineStore('reports', {
  state: () => ({
    // Estado existente para reportes de transacciones
    cashReports: {
      transactions: { data: [] },
      stats: {},
      dailyStats: {},
      loading: false,
      error: null
    },
    // Nuevo estado para estadísticas de juego
    gameStats: {
      game_stats: { data: [] },
      top_games: [],
      top_providers: [],
      daily_stats: [],
      totals: {},
      loading: false,
      error: null
    },
     // Estado para bonos
  bonusStats: {
    cashback_history: [],
    jackpot_history: [],
    status_stats: [],
    type_stats: [],
    totals: {},
    loading: false,
    error: null
  },
    // Estado común de filtros
    filters: {
      fromDate: null,
      toDate: null,
      type: 'all',
      provider: null,
      perPage: 10,
      page: 1
    },
    // Pestaña activa
    activeTab: 'transactions'
  }),
  
  actions: {
    updateFilters(newFilters) {
      this.filters = { ...this.filters, ...newFilters };
    },
    // Método existente para reportes de transacciones
    async fetchCashReports() {
      this.cashReports.loading = true;
      this.cashReports.error = null;
      
      console.log('Fetching cash reports with filters:', this.filters);
      
      try {
        const authStore = useAuthStore();
        console.log('Auth token available:', !!authStore.token);
        
        const response = await api.get('/player/reports/cash', {
          params: {
            from_date: this.filters.fromDate,
            to_date: this.filters.toDate,
            type: this.filters.type,
            per_page: this.filters.perPage,
            page: this.filters.page
          },
          headers: {
            Authorization: `Bearer ${authStore.token}`
          }
        });
        
        console.log('Cash reports response:', response.data);
        
        this.cashReports.transactions = response.data.transactions;
        this.cashReports.stats = response.data.stats;
        this.cashReports.dailyStats = response.data.daily_stats;
      } catch (error) {
        console.error('Error fetching cash reports:', error);
        console.error('Error details:', error.response?.data);
        this.cashReports.error = error.response?.data?.message || 'Error al cargar reportes';
      } finally {
        this.cashReports.loading = false;
      }
    },
    
    // Nuevo método para estadísticas de juego
   // En reportsStore.js
async fetchGameStats() {
  this.gameStats.loading = true;
  this.gameStats.error = null;
  
  try {
    const authStore = useAuthStore();
    
    const response = await api.get('/player/reports/games', {
      params: {
        from_date: this.filters.fromDate,
        to_date: this.filters.toDate,
        game: this.filters.game,
        per_page: this.filters.perPage,
        page: this.filters.page
      },
      headers: {
        Authorization: `Bearer ${authStore.token}`
      }
    });
    
    console.log('Game history response:', response.data);
    
    this.gameStats.game_history = response.data.game_history;
    this.gameStats.stats = response.data.stats;
  } catch (error) {
    console.error('Error fetching game history:', error);
    this.gameStats.error = error.response?.data?.message || 'Error al cargar historial de juego';
  } finally {
    this.gameStats.loading = false;
  }
},
async fetchBonusStats() {
  this.bonusStats.loading = true;
  this.bonusStats.error = null;
  
  try {
    const authStore = useAuthStore();
    
    const response = await api.get('/player/reports/bonuses', {
      params: {
        from_date: this.filters.fromDate,
        to_date: this.filters.toDate,
        bonus_type: this.filters.bonusType,
        status: this.filters.status,
        per_page: this.filters.perPage,
        page: this.filters.page
      },
      headers: {
        Authorization: `Bearer ${authStore.token}`
      }
    });
    
    console.log('Bonus stats response:', response.data);
    
    this.bonusStats.cashback_history = response.data.cashback_history;
    this.bonusStats.jackpot_history = response.data.jackpot_history;
    this.bonusStats.status_stats = response.data.status_stats;
    this.bonusStats.type_stats = response.data.type_stats;
    this.bonusStats.totals = response.data.totals;
  } catch (error) {
    console.error('Error fetching bonus stats:', error);
    this.bonusStats.error = error.response?.data?.message || 'Error al cargar estadísticas de bonos';
  } finally {
    this.bonusStats.loading = false;
  }
},
    
    // Método para escuchar actualizaciones en tiempo real
    initializeRealtimeUpdates() {
      // Implementación existente...
      if (window.Echo) {
        window.Echo.private(`player.${localStorage.getItem('userId')}`)
          .listen('.report.updated', (event) => {
            if (event.reportType === 'cash') {
              this.cashReports.transactions = event.data.transactions;
              this.cashReports.stats = event.data.stats;
              this.cashReports.dailyStats = event.data.daily_stats;
            } else if (event.reportType === 'game') {
              this.gameStats.game_stats = event.data.game_stats;
              this.gameStats.top_games = event.data.top_games;
              this.gameStats.top_providers = event.data.top_providers;
              this.gameStats.daily_stats = event.data.daily_stats;
              this.gameStats.totals = event.data.totals;
            }
          });
      }
    }
  },
  
  getters: {
    // Getters existentes
    formattedTransactions: (state) => {
      return state.cashReports.transactions?.data || [];
    },
    isCashReportsLoading: (state) => state.cashReports.loading,
    
    // Nuevos getters para estadísticas de juego
    isGameStatsLoading: (state) => state.gameStats.loading,
    formattedGameStats: (state) => state.gameStats.game_stats || { data: [] },
    formattedTopGames: (state) => state.gameStats.top_games || [],
    formattedTopProviders: (state) => state.gameStats.top_providers || [],
    formattedDailyStats: (state) => state.gameStats.daily_stats || [],
    gameTotals: (state) => state.gameStats.totals || {},
     // Getters para bonos
  isBonusStatsLoading: (state) => state.bonusStats.loading,
  cashbackHistory: (state) => state.bonusStats.cashback_history || [],
  jackpotHistory: (state) => state.bonusStats.jackpot_history || [],
  bonusStatusStats: (state) => state.bonusStats.status_stats || [],
  bonusTypeStats: (state) => state.bonusStats.type_stats || [],
  bonusTotals: (state) => state.bonusStats.totals || {}
  }
});